import { EnvironmentOptions } from "./constants";

export const onMobile = (): boolean => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const currentEnvironment = () => {
  return (process.env.NODE_ENV === 'development' || window.location.hostname === 'fullimpact.nixtus.dev') ? EnvironmentOptions.Development : EnvironmentOptions.Production;
};